import { FC, ReactNode } from 'react';
import usePermission from 'src/hooks/usePermissions';

interface PermissionGuardProps {
  permissions: string[];
  children: ReactNode;
  fallback?: ReactNode;
  or?: boolean;
  clientId?: string;
}

const PermissionGuard: FC<PermissionGuardProps> = ({
  permissions = [],
  children,
  fallback,
  or,
  clientId,
}) => {
  const hasPermission = usePermission({ permissions, or, clientId });

  if (permissions.length === 0) {
    return <>{children}</>;
  }

  return <>{hasPermission ? children : fallback}</>;
};

export default PermissionGuard;
